var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavePlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFF1F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6667 35C29.6667 36.1 29.9667 37.12 30.4767 38H22.6667C21.5567 38 20.6667 37.11 20.6667 36V20C20.6667 19.4696 20.8775 18.9609 21.2525 18.5858C21.6276 18.2107 22.1363 18 22.6667 18H23.6667V25L26.1667 23.5L28.6667 25V18H34.6667C35.1972 18 35.7059 18.2107 36.081 18.5858C36.456 18.9609 36.6667 19.4696 36.6667 20V29.09C36.3367 29.04 36.0067 29 35.6667 29C32.3567 29 29.6667 31.69 29.6667 35ZM36.6667 34V31H34.6667V34H31.6667V36H34.6667V39H36.6667V36H39.6667V34H36.6667Z",
    fill: "#FE544F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavePlusIcon);
export default __webpack_public_path__ + "static/media/save-plus-icon.33fd2505e8d79412a86e135967dc7b26.svg";
export { ForwardRef as ReactComponent };